import source_1 from 'src/assets/images/source1.svg';
import source_2 from 'src/assets/images/source2.svg';
import source_3 from 'src/assets/images/source3.svg';
import source_4 from 'src/assets/images/source4.svg';
import SECRETS from './secrets';

const BASE = {
    API_HOST: process.env.REACT_APP_API_BASE || SECRETS.REACT_APP_API_BASE,
    WEBSCOKET_HOST: process.env.REACT_APP_WEBSOCKET_BASE || SECRETS.REACT_APP_WEBSOCKET_BASE,
};

const OPEN_AI_STATUSES = [
    'OK',
    'Ok',
    'Journal Verification failed',
    'No matches in journals, reverting to unmatched',
    'Guard model error'
];

const PROMPT_SUGGESTIONS: string[] = [
    'Is torsion of the optic nerve head a prominent feature of normal-tension glaucoma?',
    'Are autoimmune features associated with chronic antibiotic-refractory pouchitis?',
    'Do obese patients with idiopathic pulmonary fibrosis have a higher 90-day mortality risk with bilateral lung transplantation?',
    'Does intra-articular injection of synthetic microRNA-210 accelerate avascular meniscal healing in rat medial meniscal injured model?',
    'Does tetraploid complementation prove pluripotency of induced pluripotent stem cells derived from adipose tissue? ',
    'What are the treatment guidelines for tuberculosis?',
    'Is pentraxin 3 reduced in bipolar disorder?',
    'What are the potential complications of long-term NSAID use in arthritis patients?',
];

const PDF_PROMPT_SUGGESTIONS: string[] = [
    'Summarise the key findings from this paper.',
    'Highlight the primary and secondary outcomes from this study.',
    'What are the side effects mentioned in the study?',
];

const SOURCES_ICONS = [
    source_1,
    source_2,
    source_3,
    source_4,
];

const DEFAULT_MESSAGES = {
    INTERNAL_SERVER_ERROR: 'Internal server error. Please try again!',
};

const PDF_WORKER_URL = 'https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js';

const STATIC_PLANS = [
    {
        trp_id: 'plan_free',
        trp_period: 'monthly',
        trp_name: 'Tatva_AI_Basic',
        trp_description: 'Tatva_AI_Basic_Monthly',
        trp_amount: 'FREE',
        trp_type: 'Basic'
    },
    {
        trp_id: '',
        trp_period: 'monthly',
        trp_name: 'Tatva_AI_Pro_Monthly',
        trp_description: 'Tatva_AI_Pro_Monthly',
        trp_amount: 500,
        trp_type: 'Pro'
    },
    {
        trp_id: 'plan_enterprise',
        trp_period: 'monthly',
        trp_name: 'Tatva_AI_Enterprise_Monthly',
        trp_description: 'Tatva_AI_Enterprise_Monthly',
        trp_type: 'Enterprise'
    },
    {
        trp_id: 'plan_free',
        trp_period: 'yearly',
        trp_name: 'Tatva_AI_Basic',
        trp_description: 'Tatva_AI_Basic_Yearly',
        trp_amount: 'FREE',
        trp_type: 'Basic'
    },
    {
        trp_id: '',
        trp_period: 'yearly',
        trp_name: 'Tatva_AI_Pro_Yearly',
        trp_description: 'Tatva_AI_Pro_Yearly',
        trp_amount: 4000,
        trp_actual_amount: 11988,
        trp_type: 'Pro'
    },
    {
        trp_id: 'plan_enterprise',
        trp_period: 'yearly',
        trp_name: 'Tatva_AI_Enterprise_Yearly',
        trp_description: 'Tatva_AI_Enterprise_Yearly',
        trp_type: 'Enterprise'
    }
];

const SUBSCRIPTION_CONST = {
    TATVA_AI_PRO_MONTHLY: 'Tatva_AI_Pro_Monthly',
    TATVA_AI_PRO_YEARLY: 'Tatva_AI_Pro_Yearly',
    TATVA_AI_BASIC: 'Tatva_AI_Basic',
    YEARLY: 'yearly',
    MONTHLY: 'monthly',
    BASIC: 'Basic',
    PREMIUM: 'Pro',
    ENTERPRISE: 'Enterprise',
};

const GOOGLE_FORMS = {
    CONTACT_US: 'https://forms.gle/RBYu57W6ruReLssu9',
    SUBMIT_INTREST: 'https://forms.gle/gH9mfxL9SHtESRXQA',
    CAPTURE_INTREST: 'https://script.google.com/macros/s/AKfycbxhWWP6wMqwjON9ZRDuKfXJgFKUyOpXMxG0AscB1EGIpk9sbkn-qYNXhDWBhfgzE1iY/exec'
};

export {
    BASE,
    OPEN_AI_STATUSES,
    PROMPT_SUGGESTIONS,
    SOURCES_ICONS,
    DEFAULT_MESSAGES,
    PDF_WORKER_URL,
    PDF_PROMPT_SUGGESTIONS,
    STATIC_PLANS,
    SUBSCRIPTION_CONST,
    GOOGLE_FORMS
};